import React, { createContext, useContext } from 'react';
import RemoteUnexpectedStockOutflowRepository from './hexmodules/unexpectedStockOutflow/infrastructure/remoteUnexpectedStockOutflowRepository';

const DependencyContext = createContext();

export const useDependencies = () => useContext(DependencyContext);

export const DependencyProvider = ({ children, services }) => {
  const allServices = {
    ...services,
    unexpectedStockOutflowRepository: new RemoteUnexpectedStockOutflowRepository()
  };

  return (
    <DependencyContext.Provider value={allServices}>
      {children}
    </DependencyContext.Provider>
  );
};